import cmpLoginLocal from './cmpLoginLocal';
import cmpLoginIdp from './cmpLoginIdp';
import util from './util';

export { cmpLoginLocal, util as loginUtil };
let cmpLogin = cmpLoginIdp;
if (process.env.VUE_APP_USE_IDP == 'true') {
    cmpLogin = cmpLoginIdp;
} else {
    cmpLogin = cmpLoginLocal;
}
export default cmpLogin;
